// extracted by mini-css-extract-plugin
export default {"container":"SkeletonElement_container__AqmY1","pulse":"SkeletonElement_pulse__G8aFx","rectangle":"SkeletonElement_rectangle__YdVpJ","circle":"SkeletonElement_circle__-uNs0"};